'use strict';

var BreakdownChartVieport = function BreakdownChartVieport(ChartViewport, chartXAxis, chartGroups, chartSimpleBars) {
  var chartParams = require('./ParamsViewport');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    var groups = chartGroups('date');
    var simpleBars = chartSimpleBars('model');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withRepetition(1).withoutLine();
    ChartViewport.call(this, container, chartParams, chartScales, groups, simpleBars, xAxis);
  };
  Chart.prototype = Object.create(ChartViewport.prototype);
  Chart.constructor = Chart;
  return Chart;
};
BreakdownChartVieport.$inject = ['ChartViewport', 'ChartElementsXAxis', 'ChartElementsGroup', 'ChartElementsSimpleBars'];
module.exports = BreakdownChartVieport;